import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxIntuitiveTeethOrchestratorFacade } from '../../rx-intuitive-teeth-orchestrator.facade';
import { combineLatest, takeUntil } from 'rxjs';
import { BaseDestroyableComponent } from '@shared/base-classes/base-destroyable';
import { TlkCardComponent } from '@itero/ui-toolkit-angular/card';
import { RxIntuitiveSpriteService } from '@modules/rx-intuitive-teeth-orchestrator/services/rx-intuitive-sprite-service';

/**
 * Presentational shell: diagram column + indication controls, separator, side panel.
 * Parent supplies optional `rx-intuitive-teeth-diagram-toolbar`, then `rx-intuitive-teeth-diagram-diagram`,
 * `rx-intuitive-teeth-diagram-buttons`, and `rx-intuitive-teeth-diagram-panel`.
 */
@Component({
	selector: 'rx-intuitive-teeth-orchestrator-layout',
	templateUrl: './rx-intuitive-teeth-orchestrator-layout.component.html',
	styleUrls: ['./rx-intuitive-teeth-orchestrator-layout.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TlkCardComponent, CommonModule]
})
export class RxIntuitiveTeethOrchestratorLayoutComponent extends BaseDestroyableComponent implements OnInit {
	@Input() hideSidebar = false;

	readonly upperJaw$ = this.facade.upperJaw$;
	readonly lowerJaw$ = this.facade.lowerJaw$;
	readonly injectedSpritesContent$ = this.spriteService.injectedSpritesContent$;

	constructor(
		private readonly facade: RxIntuitiveTeethOrchestratorFacade,
		private readonly spriteService: RxIntuitiveSpriteService
	) {
		super();
	}
	ngOnInit(): void {
		combineLatest([this.upperJaw$, this.lowerJaw$])
			.pipe(takeUntil(this.componentAlive$))
			.subscribe(([upper, lower]) => this.spriteService.syncInjectedSpritesContent(upper, lower));
	}

	trackByMapKey(index: number, item: { key: string }): string {
		return item.key;
	}
}
